// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__2arsj","mensagem":"OptionSelect_mensagem__3YSpG","focado":"OptionSelect_focado__2cboN"};